import diningJSON from "./disney_wdw_dining.json?raw"

export namespace DisneyData {
	type DiningExport = {
		locations: DiningLocation[]
		results: DiningResult[]
	}

	type DiningLocation = {
		id: string
		title: string
		urlFriendlyId: string
		locationType: string
	}

	type DiningResult = {
		id: string
		urlFriendlyId: string
		url: string
		name: string
		parkIds: string[]
		media: any
		facets: DiningFacet
		descriptions: any
		schedule: any
		disneyOwned: any
		generalPurposeStrings: DiningGeneralPurposeStrings
		webLinks: DiningWebLinks
		quickServiceAvailable: boolean
		productUrls: string[]
		restaurants: any
		maximumPartySize: string
		locationName?: string
		facilityId: string
		restaurantsIds: string[]
		entityType: string
		entityTypeName: string
		openHours: any
		parkTicketsCta: any
		remyCheckAvailCta?: DiningRemyCheckAvailCta
		facetsLabel: string
		facetGroupType: string
		type: DiningType
		siteId: string
		marker: any
	}

	type DiningFacet = {
		additionalInfo: string[]
		annualPass: string[]
		behaviorType: string[]
		checkAvailability: string[]
		dining: string[]
		diningPlan: string[]
		guestRating: string[]
		itinerary: string[]
		type?: string[]
		features?: string[]
		priceRangeDining?: string[]
		reservationOfferings: string[]
		tableService: string[]
		"wdw-finder-listing": string[]
		"wdw-mobile-listing": string[]
	}

	type DiningGeneralPurposeStrings = Record<string, string>

	type DiningWebLinks = {
		wdwDetail: DiningWebLink
		reservableExperience: DiningWebLink
	}

	type DiningWebLink = {
		href: string
		title: string
	}

	type DiningRemyCheckAvailCta = {
		icon: string
		href: string
		label: string
		target: string
	}

	type DiningType = {
		facets: string
	}

	// https://disneyworld.disney.go.com/finder/api/v1/explorer-service/list-ancestor-entities/wdw/80007798;entityType=destination/2026-01-30/dining
	export const DiningDataExport: DiningExport = JSON.parse(diningJSON)
}
